module.exports = __webpack_public_path__ + "img/task4.d13e809f.png";